namespace Gamification.Gamification {
    export interface UtentiForm {
        IdUtente: Serenity.IntegerEditor;
        IdentifierUtente: Serenity.StringEditor;
        Email: Serenity.EmailAddressEditor;
        ConfirmEmail: Serenity.EmailAddressEditor;
        Locked: Serenity.BooleanEditor;
        IdProdotto: Serenity.LookupEditor;
        Classi: Serenity.LookupEditor;
    }

    export class UtentiForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.Utenti';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!UtentiForm.init)  {
                UtentiForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.EmailAddressEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.LookupEditor;

                Q.initFormType(UtentiForm, [
                    'IdUtente', w0,
                    'IdentifierUtente', w1,
                    'Email', w2,
                    'ConfirmEmail', w2,
                    'Locked', w3,
                    'IdProdotto', w4,
                    'Classi', w4
                ]);
            }
        }
    }
}
